import React from "react";

const PromotionalTwo = () => {
  return (
    <section className="sx-smart-section">
      <div className="sx-smart-container">
        {/* LEFT VISUAL */}
        <div className="sx-smart-visual">
          <div className="sx-smart-card">
            <img
              src="/assets/images/bg/banner-thumb.png"
              alt="Smart Printer Control"
            />
          </div>
        </div>

        {/* RIGHT CONTENT */}
        <div className="sx-smart-content">
          <span className="sx-smart-label">Smart Printing</span>

          <h2 className="sx-smart-title">
            Control Printing <br />
            From Anywhere
          </h2>

          <p className="sx-smart-text">
            Printing doesn’t have to be tied to a single desk. With the right
            configuration and setup, you can manage print related tasks more
            efficiently whether you're at home, in the office, or on the go.
          </p>

          <div className="sx-smart-features">
            <div className="sx-smart-item">
              <h4>Scan & Share Easily</h4>
              <p>
                Capture documents digitally and send them where needed without
                unnecessary steps or delays.
              </p>
            </div>

            <div className="sx-smart-item">
              <h4>Stay Organized</h4>
              <p>
                Keep documents structured and accessible so important files are
                always easy to find.
              </p>
            </div>

            <div className="sx-smart-item">
              <h4>Quick Everyday Actions</h4>
              <p>
                Perform routine printing tasks smoothly with minimal setup and
                fewer interruptions.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* CSS */}
      <style>{`
        /* ================= SECTION ================= */
        .sx-smart-section {
          padding: 100px 0;
          background: #f9fafb; /* NOT CHANGED */
        }

        .sx-smart-container {
          max-width: 1200px;
          margin: auto;
          padding: 0 20px;
          display: flex;
          align-items: center;
          gap: 70px;
        }

        /* ================= VISUAL ================= */
        .sx-smart-visual {
          flex: 1;
          display: flex;
          justify-content: center;
        }

        .sx-smart-card {
          box-shadow: 0 25px 50px rgba(0,0,0,0.12);
        }

        .sx-smart-card img {
          display: block;
        }

        /* ================= CONTENT ================= */
        .sx-smart-content {
          flex: 1.2;
        }

        .sx-smart-label {
          display: inline-block;
          font-size: 12px;
          font-weight: 700;
          letter-spacing: 1px;
          color: #2563eb;
          text-transform: uppercase;
          margin-bottom: 14px;
        }

        .sx-smart-title {
          font-size: 38px;
          font-weight: 800;
          line-height: 1.25;
          color: #111827;
          margin-bottom: 20px;
        }

        .sx-smart-text {
          font-size: 16px;
          line-height: 1.7;
          color: #4b5563;
          max-width: 560px;
          margin-bottom: 28px;
        }

        /* ================= FEATURES ================= */
        .sx-smart-features {
          display: flex;
          flex-direction: column;
          gap: 20px;
        }

        .sx-smart-item h4 {
          font-size: 17px;
          font-weight: 700;
          color: #111827;
          margin-bottom: 6px;
        }

        .sx-smart-item p {
          font-size: 15px;
          line-height: 1.6;
          color: #6b7280;
          margin: 0;
          max-width: 520px;
        }

        /* ================= MOBILE ================= */
        @media(max-width: 900px) {
          .sx-smart-container {
            flex-direction: column;
            text-align: center;
          }

          .sx-smart-title {
            font-size: 30px;
          }

          .sx-smart-text,
          .sx-smart-item p {
            margin-left: auto;
            margin-right: auto;
          }
        }
      `}</style>
    </section>
  );
};

export default PromotionalTwo;
